import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ApiProcedimientosService } from 'src/app/services/api-procedimientos.service';
import { ApiDownloadFileService } from '../../../services/api-download-file.service';

declare var $: any;

@Component({
  selector: 'app-procedimientos-det-obra',
  templateUrl: './procedimientos-det-obra.component.html',
  styleUrls: ['./procedimientos-det-obra.component.css']
})
export class ProcedimientosDetObraComponent implements OnInit {


  public datosGrales: any[] = [];
  public plazos: any[] = [];
  public anexos: any[] = [];
  public anio: string;
  public idProc: string;
  public feclimcot: string;

  public mensajeError: string = 'Ha ocurrido un error, comunicarse al Departamento de Sistemas.';

  @ViewChild('downloadLink', {static: false}) downloadLink: ElementRef;
  constructor(private router: Router,
              private ruta: ActivatedRoute,
              private apiProcedimientos: ApiProcedimientosService,
              private apiDownload: ApiDownloadFileService) {
    this.anio = this.ruta.snapshot.params.anio;
    this.idProc = this.ruta.snapshot.params.idProc;
  }

  ngOnInit() {
    $('#mod_procesando').modal('show');
    this.readDatosGrales(this.anio, this.idProc);
  }

  readDatosGrales(anio: string, idProcedimiento: string) {
    this.apiProcedimientos.getDatosGenerales(anio, idProcedimiento).subscribe(data => {
      if(data[0].success){
        this.datosGrales = JSON.parse(data[0].info);
        this.feclimcot = this.datosGrales[0].FECFINPUB;
        this.feclimcot = this.feclimcot.replace(/-/g,"/");
        console.log(this.datosGrales);
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);
        this.readAnexos(this.datosGrales[0].IACTIDO_PK_CVETID, anio, idProcedimiento);
      } else {
        this.mensajeError = 'Ha ocurrido un error al obtener los datos del procedimiento.';
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.mensajeError = 'Ha ocurrido un error al obtener los datos del procedimiento.';
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }


  readAnexos(iActido: string, anio: string, idProcedimiento: string) {
    this.apiProcedimientos.getAnexos(iActido, anio, idProcedimiento).subscribe(data => {
      if(data[0].success){
        this.anexos = JSON.parse(data[0].info);
        $(document).ready(function () {
          let tbl_anexos = $('#tbl_anexos').DataTable({
            //dom: '<"row">ltp',
            //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ]
          });

          // $('#txt_anexos').on( 'keyup', function () {
          //   tbl_anexos.search( this.value ).draw();
          // });
        });
        this.readPlazos(anio, idProcedimiento);
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);

      } else {
        this.mensajeError = 'Ha ocurrido un error al obtener los datos de los anexos.';
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.mensajeError = 'Ha ocurrido un error al obtener los datos de los anexos.';
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  readPlazos(anio: string, idProcedimiento: string) {
    this.apiProcedimientos.getPlazoFec(anio, idProcedimiento, null).subscribe(data => {
      if(data[0].success){
        this.plazos = JSON.parse(data[0].info);
        console.log('Plazos');
        console.log(this.plazos);
        $(document).ready(function () {
          let tbl_plazos = $('#tbl_plazos').DataTable({
            //dom: '<"row">ltp',
            //dom: '<"#positionFilter">ltp',
        paging: true,       //Oculta controles y etiquetas de paginación
        searching: true,    //Dejar en true para conservar funcionalidades de busqueda en columnas.
        info: false,        //Oculta etiquetas de cantidad de registros disponibles y filtrados.
        autoWidth: false,   //Impide que calcule automaticamente el ancho de las columnas.
        processing: true,
        bSort: false,
        renderer: 'bootstrap',
        dom: "<'row'<'col-sm-10'B><'col-sm-2'>>tp",
        "lengthMenu": [[10, 25, 50, -1], ["Mostrar 10", "Mostrar 25", "Mostrar 50", "Mostrar Todos"]],
        language: {
          "sSearch": "Buscar:",
          "sProcessing": "Procesando...",
          "sLengthMenu": "_MENU_ REGISTROS",
          "sZeroRecords": "No se encontraron resultados",
          "sEmptyTable": "Ningún dato disponible en esta tabla",
          "sInfo": "Mostrando registros del _START_ al _END_ de un total de _TOTAL_ registros",
          "sInfoEmpty": "Mostrando registros del 0 al 0 de un total de 0 registros",
          "sInfoFiltered": "(filtrado de un total de _MAX_ registros)",
          "sInfoPostFix": "",
          "oPaginate": {
              "sFirst": "Primero",
              "sLast": "Último",
              "sNext": "SIGUIENTE",
              "sPrevious": "ANTERIOR"
          },
          buttons: {
              pageLength: {
                  _: '<span><i class="fal fa-list-ul mr-2"></i></span> %d REGISTROS',
                  //1: '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos',
                  '-1': '<span><i class="fal fa-list-ul mr-2"></i></span> Mostrar Todos'
              }
          }
      },
      buttons: [
            {
              extend: 'pageLength',
              className: 'btn uaa-btn-outline btn-sm dropdown-toggle'
          }
      ]
          });

          // $('#txt_anexos').on( 'keyup', function () {
          //   tbl_anexos.search( this.value ).draw();
          // });
        })
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
        }, 500);

      } else {
        this.mensajeError = 'Ha ocurrido un error al obtener los datos de los plazos.';
        setTimeout(() => {
          $('#mod_procesando').modal('hide');
          $('#error').modal('show');
        }, 500);
      }
    },
    error => {
      this.mensajeError = 'Ha ocurrido un error al obtener los datos de los plazos.';
      setTimeout(() => {
        $('#mod_procesando').modal('hide');
        $('#error').modal('show');
      }, 500);
    });
  }

  download(cve_docto: string, nombre: string) {
    this.apiDownload.downloadFile(cve_docto).subscribe(result => {
      let url = window.URL.createObjectURL(result);

      const link = this.downloadLink.nativeElement;
      link.href = url;
      link.download = nombre;
      link.click();

      window.URL.revokeObjectURL(url);
    });
  }

}
